import React from "react";
import { Grid } from "@mui/material";
import ShimsCard from "./components/cards/ShimsCard";
import StatsCard from "./components/cards/StatsCard";

export default function SummaryContainer(props)
{
    return (
        <Grid container direction="row" spacing={1} >
            <Grid item xs={6}>
                <ShimsCard />
            </Grid>
            <Grid item xs={6}>
                <StatsCard />
            </Grid>
        </Grid>
    )
}